import { Typography } from '@mui/material'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { DOCUMENT_ROW_MENU_ITEMS } from './documentsRowMenuConfig'
import styles from './documentsPage.module.scss'
import { useDocumentsTableMenu } from './useDocumentsTableMenu'
import { DocumentsGridCard } from './DocumentsGridCard.jsx'

/**
 * @param {{
 *   items: import('./documentsDemoData').DocumentItem[],
 *   pickerMode?: boolean,
 *   selectedIds?: Set<string>,
 *   onToggleSelect?: (id: string) => void,
 * }} props
 */
export default function DocumentsGrid({ items, pickerMode = false, selectedIds, onToggleSelect }) {
  const menu = useDocumentsTableMenu()

  if (items.length === 0) {
    return (
      <div className={styles.emptyState}>
        <Typography variant="body2" color="text.secondary">
          No documents match your search.
        </Typography>
      </div>
    )
  }

  return (
    <>
      <div className={styles.gridRoot} role="list" aria-label="Documents grid">
        {items.map((item) => (
          <div key={item.id} role="listitem" className={styles.gridItem}>
            <DocumentsGridCard
              item={item}
              menu={menu}
              pickerMode={pickerMode}
              isSelected={Boolean(selectedIds?.has(item.id))}
              onToggleSelect={onToggleSelect}
            />
          </div>
        ))}
      </div>
      {pickerMode ? null : (
        <FloatingMenuPopup
          open={menu.openMenu}
          anchorEl={menu.menuAnchor}
          onClose={menu.handleCloseMenu}
          items={DOCUMENT_ROW_MENU_ITEMS}
          onItemSelect={menu.handleSelectMenuItem}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          menuListId="documents-grid-actions-menu"
          menuListAriaLabel="Document actions"
        />
      )}
    </>
  )
}
